<template>
    <small>
        Gastos de gestión no incluidos -
        <span v-if="gastos_online['interno'] == 1">
            (Online: 0€ / {{ parseFloat(importe) | formatear_precio }}) -
        </span>
        <span v-else>
            (Online: {{ gastos_online }}€ / {{ parseFloat(importe) + parseFloat(gastos_online) | formatear_precio }}) -
        </span>

        <span v-if="gastos_taquilla['interno'] == 1">
            (Taquilla: 0€ / {{ parseFloat(importe) | formatear_precio }}) -
        </span>
        <span v-else>
            (Taquilla: {{ gastos_taquilla }}€ / {{ parseFloat(importe) + parseFloat(gastos_taquilla) | formatear_precio }})
        </span>
    </small>
</template>

<script>
    export default {
        props: ['gd_online', 'gd_taquilla', 'importe'],
        computed: {
            gastos_online() {
                var cantidad = this.gd_online['cantidad'];

                if(this.gd_online['modalidad']) {
                    cantidad = cantidad / 100;
                    cantidad = this.importe * cantidad; 
                }

                cantidad = this.round(cantidad, 2);

                if(this.gd_online['interno']) {
                    return cantidad;
                } else {
                    return cantidad;
                }
            },
            gastos_taquilla() {
                var cantidad = this.gd_taquilla['cantidad'];

                if(this.gd_taquilla['modalidad']) {
                    cantidad = cantidad / 100;
                    cantidad = this.importe * cantidad; 
                }

                cantidad = this.round(cantidad, 2);

                if(this.gd_taquilla['interno']) {
                    return cantidad;
                } else {
                    return cantidad;
                }
            }
        },
        methods: {
            round(num, decimales = 2) {
                var signo = (num >= 0 ? 1 : -1);
                num = num * signo;
                if(decimales === 0) //con 0 decimales
                    return signo * Math.round(num);
                // round(x * 10 ^ decimales)
                num = num.toString().split('e');
                num = Math.round(+(num[0] + 'e' + (num[1] ? (+num[1] + decimales) : decimales)));
                // x * 10 ^ (-decimales)
                num = num.toString().split('e');
                return signo * (num[0] + 'e' + (num[1] ? (+num[1] - decimales) : -decimales));
            },
        }
    }
</script>